import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import F1Heading from '../F1Components/F1Heading'
import Image from 'next/future/image'
import raceingImage from '@assets/images/racing.svg'
import raceingImageWhite from '@assets/images/racing-white.svg'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

function F1HallOfFameDetail({ hallOfFameDetailData }) {
  const globalEvents = useContext(GlobalEventsContext)
  const { stateGlobalEvents } = globalEvents || {}
  const data = hallOfFameDetailData?.data
  return (
    <>
      <div className="flex flex-column">
        <h1 className={styles.top_header}>{data?.sTitle}</h1>
        <F1Heading title={data?.sFullName} />
      </div>
      <div className={styles.header_image_section}>
        <div className={styles.image_section}>
          <Image
            src={data?.sHeroImageUrl}
            alt={data?.sHeroImageCaption || 'Hero Image'}
            fill
            className={styles.image} />
        </div>
        <Image src={(stateGlobalEvents && stateGlobalEvents?.darkModeEna === 'dark') ? raceingImageWhite : raceingImage} alt='Hall of Fame Racing Image' className={styles.racing_image} />

      </div>

      <div className={styles.paragraph_container}>
        {data && data?.aBiography.slice(0, 3).map((item, idx) => <p key={idx}> {item?.sParagraph} </p>)}
      </div>
      <div className={styles.middle_image_container}>
        <div className={styles.middle_image_section1}>
          <Image
            src={data?.sMiddleImageOneUrl}
            alt={data?.sHeroImageCaption || 'Hero Image'}
            fill
            className={styles.middle_image} />
        </div>
        <div className={styles.middle_image_section2}>
          <Image
            src={data?.sMiddleImageTwoUrl}
            alt={data?.sHeroImageCaption || 'Hero Image'}
            fill
            className={styles.middle_image} />
        </div>
      </div>
      <div className={styles.paragraph_container}>
        {data && data?.aBiography.slice(3, 6).map((item, idx) => <p key={idx}> {item?.sParagraph} </p>)}
      </div>

      <div className={styles.header_image_section}>
        <div className={styles.image_section}>
          <Image
            src={data?.sLastImageOneUrl}
            alt={data?.sHeroImageCaption || 'Hero Image'}
            fill
            className={styles.image} />
        </div>
        <Image src={(stateGlobalEvents && stateGlobalEvents?.darkModeEna === 'dark') ? raceingImageWhite : raceingImage} alt='Hall of Fame Racing Image' className={styles.racing_image} />
      </div>

      <div className={styles.paragraph_container}>
        {data && data?.aBiography.slice(6).map((item, idx) => <p key={idx}> {item?.sParagraph} </p>)}
      </div>
    </>
  )
}

F1HallOfFameDetail.propTypes = {
  hallOfFameDetailData: PropTypes.object
}

export default F1HallOfFameDetail
